/**
 * Action types for the PayableWorkflow data reducer
 * These constants define the available actions that can be dispatched to update payable state
 */
export enum PayableActionTypes {
  SET_CLIENT = "SET_CLIENT",
  SET_PAYEE = "SET_PAYEE",
  SET_DOCUMENTS = "SET_DOCUMENTS",
  SET_ENTITY = "SET_ENTITY",
  SET_INVOICE_DETAILS = "SET_INVOICE_DETAILS",
  SET_PAYMENT_DETAILS = "SET_PAYMENT_DETAILS",
}

/**
 * Action types for the PayableWorkflow step reducer
 * These constants define the available actions that can be dispatched to control step navigation
 */
export enum PayableStepActionTypes {
  INCREMENT_STEP = "INCREMENT_STEP",
  DECREMENT_STEP = "DECREMENT_STEP",
}
